import { render } from "./TeikiList.vue?vue&type=template&id=71b98a62"
import script from "./TeikiList.vue?vue&type=script&lang=js"
export * from "./TeikiList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__